var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:[
    'spinner spinner-gritcode',
    _vm.spinnerSize,
    { 'spinner-fixed': _vm.fixed } ]},[_c('div',{staticClass:"spinner-wrapper"},[_c('div',{staticClass:"spinner-circle"}),_vm._v(" "),_c('div',{staticClass:"spinner-text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }